import { ListSelect } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const RuleIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <ListSelect width={size} height={size} color={color} {...rest} />;

RuleIcon.displayName = 'RuleIcon';

export default RuleIcon;
